import { Component, Input, OnInit } from '@angular/core';
import { AccountService } from 'src/app/services/account.service';
import { ApiService } from 'src/app/services/api.service';
import { Observable, timer } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss']
})
export class SideNavComponent implements OnInit {
isDarkTheme: boolean = false;
@Input() hideOnHover: boolean = false;
@Input() moduleName: string = 'requests-analysis';
nowDate!: Date;
  nowTime$: Observable<Date> = timer(0, 1000).pipe(map(() => new Date()));
  lang!: string;
  constructor(
    private _service: ApiService,
    private accService: AccountService,
  ) {
      this.nowDate = new Date();
   }
  username
  ngOnInit(): void {
    this.username = sessionStorage.getItem('userName');
    this.isDarkTheme =
    localStorage.getItem("darktheme") == "dark" ? true : false;
    let html = document.querySelector('html');
    let lang: string = localStorage.getItem('lang') || 'en';
    html?.setAttribute('dir', lang == 'en' ? 'ltr' : 'rtl');
    html?.setAttribute('lang', lang == 'en' ? 'en' : 'ar');
    html?.setAttribute('data-theme', this.isDarkTheme == true ? 'dark' : 'light');

  }
  logout() {
    this._service.logOut(this.username).subscribe(
      (res) => {
        this.accService.logout();
      },
      (err) => {
      }
    );
  }

}
